import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=148b8f7c&scoped=true&"
import script from "./Options.vue?vue&type=script&lang=ts&"
export * from "./Options.vue?vue&type=script&lang=ts&"
import style0 from "./Options.vue?vue&type=style&index=0&id=148b8f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148b8f7c",
  null
  
)

export default component.exports